import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';

@Injectable({
  providedIn: 'root'
})
export class PreAuthGuard {
  constructor(private storageService: StorageService) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let idToken = (this.storageService.getSessionStorage('msal.idtoken') && this.storageService.getCookie('msal.idTokenExpiry')) ?
      this.storageService.getSessionStorage('msal.idtoken') : '';
      if (idToken) {
        return true;
      }
      return false;
  }

}
export const PreauthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return inject(PreAuthGuard).canActivate(route, state);
}